<script>
export default {
    name: 'SignActionButton',
    components: {
        CpButton: require('../../button').default,
        CpBaseSvgIcon: require('../../base-svg-icon').default,
        CpIcon: require('../../icon').default,
        CpDialog: require('../../dialog').default,
        CpAuthForm: require('../../auth-form/index').default,
        SignButtonIcon: require('../../social-feed/icons/sign').default,
    },
    props: {
        id: Number,
        handleSignModal: Function,
        isSigned: Boolean,
    },
};
</script>

<template>
    <div>
        <cp-button noborder bold class="button--darkgray-outline" @click="handleSignModal" :disabled="isSigned">
            <cp-base-svg-icon :width="20" :height="20" viewBox="0 0 90 105" icon-color="var(--primary-blue-400)" :stroke-color="'currentColor'">
                <sign-button-icon />
            </cp-base-svg-icon>
            <span v-if="!$root.isMobile" class="action-button-text pt-text primary-blue-400-color">Sign</span>
        </cp-button>
    </div>
</template>

<style scoped>
.pt-text {
    padding-top: 2px;
}
.button--darkgray-outline {
    transition: color 0.2s ease;
}
</style>
